(function (root) {
  'use strict';

  var DAY_MS = 86400000;
  var MAX_DAY = Date.parse('9999-12-31T00:00:00Z') / DAY_MS;
  var UNKNOWN_TEXT = 'お届け予定時期未定';

  function parseDay(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    var timestamp = Date.parse(value + 'T00:00:00Z');
    if (!Number.isFinite(timestamp) || new Date(timestamp).toISOString().slice(0, 10) !== value) return null;
    return timestamp / DAY_MS;
  }

  function readLeadDays(value) {
    if (value == null || value === '') return 0;
    if (typeof value !== 'number' && (typeof value !== 'string' || !/^[+-]?\d+$/.test(value))) return NaN;
    var days = Number(value);
    return Number.isSafeInteger(days) ? days : NaN;
  }

  function collectSkipDays(settings) {
    var lists = [settings.globalHolidays, settings.globalDisabledDates, settings.location.disabledDates];
    var days = new Set();
    for (var i = 0; i < lists.length; i += 1) {
      if (lists[i] == null) continue;
      if (!Array.isArray(lists[i])) return null;
      lists[i].forEach(function (value) {
        var day = parseDay(value);
        if (day !== null) days.add(day);
      });
    }
    return Array.from(days).sort(function (a, b) { return a - b; });
  }

  function calculate(input, settings) {
    if (!input || input.isPreOrder !== true) return '';
    if (!settings || !settings.location || settings.location.found !== true) return UNKNOWN_TEXT;

    var startDay = parseDay(input.scheduledShippingDate);
    var today = parseDay(settings.today);
    var orderLeadDays = readLeadDays(input.orderLeadDays);
    var locationLeadDays = readLeadDays(settings.location.leadDays);
    var leadDays = orderLeadDays + locationLeadDays;
    if (startDay === null || today === null || startDay < today ||
        !Number.isSafeInteger(leadDays)) return UNKNOWN_TEXT;

    var skipDays = collectSkipDays(settings);
    if (skipDays === null) return UNKNOWN_TEXT;

    for (var i = 0; i < skipDays.length; i += 1) {
      if (skipDays[i] === startDay) startDay += 1;
      else if (skipDays[i] > startDay) break;
    }

    var deliveryDay = startDay + Math.max(0, leadDays);
    for (var j = 0; j < skipDays.length; j += 1) {
      if (skipDays[j] > deliveryDay) break;
      if (skipDays[j] > startDay) deliveryDay += 1;
    }
    if (!Number.isSafeInteger(deliveryDay) || deliveryDay > MAX_DAY) return UNKNOWN_TEXT;

    var date = new Date(deliveryDay * DAY_MS);
    var day = date.getUTCDate();
    var period = day <= 10 ? '上旬' : day <= 20 ? '中旬' : '下旬';
    return (date.getUTCMonth() + 1) + '月' + period + 'お届け予定';
  }

  function readSettings(context) {
    var script = context && context.querySelector('script[data-preorder-delivery-settings]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function applyToVariants(variants, settings) {
    Object.keys(variants).forEach(function (id) {
      var info = variants[id];
      if (info && Object.prototype.hasOwnProperty.call(info, 'preorder_delivery')) {
        info.shipping = calculate(info.preorder_delivery, settings) || null;
      }
    });
    return variants;
  }

  function render(context) {
    var settings = readSettings(context);
    context.querySelectorAll('[data-preorder-delivery-input]').forEach(function (element) {
      var text;
      try {
        text = calculate(JSON.parse(element.getAttribute('data-preorder-delivery-input')), settings);
      } catch (error) {
        text = UNKNOWN_TEXT;
      }
      element.textContent = text;
      element.hidden = !text;
    });
  }

  var api = {
    calculate: calculate,
    readSettings: readSettings,
    applyToVariants: applyToVariants,
    render: render
  };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.NissenPreorderDelivery = api;
})(typeof window === 'undefined' ? globalThis : window);
